module.exports = __webpack_public_path__ + "img/vilshofen.aca157b.jpg";